import { type News, type NewsItemActionCreate } from '@common/clients/api';
import { NewsService } from '@common/clients/api/generated/sdk.gen';
import { createApiClient } from '@common/clients/request/api-client';
import { type ContextData } from '@common/defaults/ContextData';
import { type UserContext } from '@common/defaults/UserContext';

export async function createNews({
    requestBody,
    contextData,
    userContext,
}: {
    requestBody: NewsItemActionCreate;
    contextData: ContextData;
    userContext: UserContext;
}): Promise<News> {
    const client = createApiClient({ contextData, userContext });

    const { data } = await NewsService.createNewsByDomainId({
        client,
        path: {
            contextID: contextData.context.id,
        },
        body: requestBody,
        throwOnError: true,
    });

    return data;
}
